import { getCookie, setJusbrasilCookie } from '@jusbrasil-web/shared-utils-cookies'

import {
  COMPLETE_SIGNUP_NUDGE_SNOOZE_COOKIE_PREFIX,
  COMPLETE_SIGNUP_NUDGE_SNOOZE_MAX_AGE_SECONDS,
} from './constants'

function snoozeCookieName(pid: string | number): string {
  return `${COMPLETE_SIGNUP_NUDGE_SNOOZE_COOKIE_PREFIX}${pid}`
}

export function isCompleteSignupNudgeSnoozed(pid: string | number): boolean {
  return !!getCookie(null, snoozeCookieName(pid))
}

export function snoozeCompleteSignupNudge(pid: string | number, nowIso: string): void {
  setJusbrasilCookie(null, snoozeCookieName(pid), nowIso, {
    maxAge: COMPLETE_SIGNUP_NUDGE_SNOOZE_MAX_AGE_SECONDS,
  })
}
